import { useCallback } from 'react';
import { useVoice } from '@/context/VoiceContext';
import { normalizePhone, isMobileDevice } from '@/lib/phone';

// Click handler for tel: anchors: desktop -> Quick Dial (prefilled + dial), mobile -> native dialer
export function useDialClick() {
  const { requestDial } = useVoice();
  return useCallback((e, number, name) => {
    if (e) e.stopPropagation();
    if (!number) return;
    if (isMobileDevice()) return;
    if (e) e.preventDefault();
    requestDial(normalizePhone(number), name || number, true);
  }, [requestDial]);
}
